import React, { Component } from "react";
// import "../style.css";
import "./DistanceTable.css";
import _ from "lodash";
import * as d3 from "d3";
import Table from "../Table/index";
import { getReportDownload } from "../JSONCSV";
import moment from "moment";
import EmptyState from "../../../../../../../assets/svg/evNoData.svg";
const colors = ["#5bcc5b", "#5eaaa8", "#ffc478", "#f05f5f", "#01bffe"];

class DistanceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredData: [],
      sortBy: null,
      viewIdx: 0,
      chartType: 0,
    };
  }

  componentDidMount() {
    // this.setState({ filteredData: this.getTableData() });
    this.renderBubble();
  }
  getCSVName() {
    let auth = window.auth;
    let date = moment().format("DD-MM-YYYY_Hmm");
    return auth.userinfo.username + "_Charge_Utilization_" + date;
  }

  renderLegends() {
    let data = this.processChartData(
      this.state.chartType == 1
        ? this.props.data.distribution.distance
        : this.props.data.distribution.chargeused
    );
    let legends = [];
    for (let idx in data) {
      legends.push(
        <li key={idx} style={{ boxShadow: "none", justifyContent: "flex-end" }}>
          <span className="secElem" style={{ fontSize: 11, marginRight: 5 }}>
            {" "}
            {data[idx].range} {this.state.chartType === 0 ? "%" : "km"}
          </span>
          <div className="firstElem">
            <div style={{ backgroundColor: colors[idx] }}></div>
          </div>
        </li>
      );
    }
    return legends;
  }
  processChartData(data, unit) {
    let entries = Object.entries(data);
    let finalData = [];
    for (let idx in entries) {
      finalData.push({
        range: entries[idx][1][0] + unit,
        value: entries[idx][1][1],
      });
    }
    return finalData;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isExpanded == "ct006") {
      this.renderBubble(400, 260);
    }
  }

  renderBubble(refWidth = 300, refHeight = 180) {
    let data = this.processChartData(
      this.state.chartType == 1
        ? this.props.data.distribution.distance
        : this.props.data.distribution.chargeused,
      this.state.chartType == 1 ? "km" : "%"
    );
    var margin = { top: 30, right: 20, bottom: 30, left: 10 },
      width = refWidth - margin.left - margin.right,
      height = refHeight - margin.top - margin.bottom;

    // set the ranges
    var x = d3.scaleBand().range([0, width]).padding(0.1);
    var y = d3.scaleLinear().range([height, 0]);

    // append the svg object to the body of the page
    // append a 'group' element to 'svg'
    // moves the 'group' element to the top left margin

    var svg = d3.select(this.refs.bubbleEV);
    svg.selectAll("svg").remove();

    var svg = d3
      .select(this.refs.bubbleEV)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // format the data
    data.forEach(function (d) {
      d.value = +d.value;
    });

    // Scale the range of the data in the domains
    x.domain(
      data.map(function (d) {
        return d.range;
      })
    );
    y.domain([
      0,
      d3.max(data, function (d) {
        return d.value;
      }),
    ]);

    // append the rectangles for the bar chart
    svg
      .selectAll(".bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", function (d) {
        return x(d.range) + 10;
      })
      .attr("width", 30)
      .attr("fill", function (d, i) {
        return colors[i];
      })
      .attr("y", function (d) {
        return y(d.value);
      })
      .attr("height", function (d) {
        return height - y(d.value);
      });

    // add the x Axis
    svg
      .append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x));

    svg
      .selectAll(".text")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "label")
      .attr("x", function (d) {
        return x(d.range) + 25;
      })
      .attr("y", function (d) {
        return y(d.value) - 20;
      })
      .attr("dy", "1.2em")
      .attr("font-size", "12px")
      .attr("text-anchor", "middle")
      .attr("class", "barLabel")

      .text(function (d) {
        return d.value;
      });
  }

  searchReport(key) {
    var filter, table, tr, td, i, txtValue;
    filter = key.toUpperCase();
    table = document.getElementById("chargeUtilTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  minimizeWidget(id) {
    this.props.setExpand(id);
    this.renderBubble(300, 180);
  }

  render() {
    return (
      <div
        className={
          "widgetLayout " +
          (this.props.isExpanded === "ct006" ? "expandedWidget " : "")
        }
      >
        <div className="header">
          <div>Charge Utilization</div>

          <div
            className="rightIcons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: 50,
              alignItems: "center",
            }}
          >
            <i
              onClick={() =>
                getReportDownload(
                  this.props.data.history,
                  this.props.heads,
                  this.getCSVName()
                )
              }
              className="fa fa-download"
            ></i>
            {this.props.isExpanded == "ct006" ? (
              <i
                onClick={() => this.minimizeWidget("ct006")}
                className="fa fa-window-minimize"
              ></i>
            ) : (
              <i
                onClick={() => this.props.setExpand("ct006")}
                className="fa fa-window-maximize"
              ></i>
            )}
          </div>
        </div>
        {this.props.data.history.length > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {this.state.viewIdx === 0 ? (
              <div className="topAction">
                <ul>
                  <li
                    onClick={() =>
                      this.setState({ chartType: 0 }, () => {
                        this.renderBubble(
                          this.props.isExpanded == "ct006" ? 400 : 300,
                          this.props.isExpanded == "ct006" ? 260 : 180
                        );
                      })
                    }
                    className={this.state.chartType === 0 ? "active" : ""}
                  >
                    Charge Used
                  </li>
                  <li
                    onClick={() =>
                      this.setState({ chartType: 1 }, () => {
                        this.renderBubble(
                          this.props.isExpanded == "ct006" ? 400 : 300,
                          this.props.isExpanded == "ct006" ? 260 : 180
                        );
                      })
                    }
                    className={this.state.chartType === 1 ? "active" : ""}
                  >
                    Distance
                  </li>
                </ul>
              </div>
            ) : (
              <div
                className="searchBox"
                style={{
                  marginLeft: 12,
                  marginTop: 9,
                  width: this.props.isExpanded == "ct006" ? 295 : 150,
                }}
              >
                <input
                  type="text"
                  placeholder="search"
                  style={{
                    padding: "3px 8px",
                    borderRadius: 15,
                    width: "100%",
                    border: "1px solid #b1b1b1",
                    fontSize: 11,
                    color: "#4c4a4a",
                  }}
                  onChange={(e) => this.searchReport(e.target.value)}
                />
              </div>
            )}
            <div className="topAction">
              <ul>
                <li
                  onClick={() =>
                    this.setState({ viewIdx: 0 }, () => {
                      this.renderBubble(
                        this.props.isExpanded == "ct006" ? 400 : 300,
                        this.props.isExpanded == "ct006" ? 260 : 180
                      );
                    })
                  }
                  className={this.state.viewIdx === 0 ? "active" : ""}
                >
                  Chart
                </li>
                <li
                  onClick={() => this.setState({ viewIdx: 1 })}
                  className={this.state.viewIdx === 1 ? "active" : ""}
                >
                  Table
                </li>
              </ul>
            </div>
          </div>
        ) : null}
        {this.state.viewIdx === 0 ? (
          <div className="widgetbody">
            {this.props.data.history.length > 0 ? (
              <div className="widgetContainer" style={{ alignItems: "start" }}>
                <div
                  id="bubbleEV"
                  ref="bubbleEV"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></div>
                {/* <div className="legends" style={{marginTop:10}}>
                <ul>{this.renderLegends()}</ul>
              </div> */}
              </div>
            ) : (
              <img style={{ width: 200 }} src={EmptyState} />
            )}
          </div>
        ) : (
          <div className="tableView">
            <Table
              updateData={this.props.updateData}
              ref={(ref) => {
                this.child = ref;
              }}
              data={this.props.data.history}
              heads={this.props.heads}
              metric="todaydistance"
              tableId="chargeUtilTable"
            />
          </div>
        )}
      </div>
    );
  }
}

export default DistanceTable;
